import  { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { checkUserStatusAndRedirect } from 'src/api/types/commonLogout';
const RouteChangeHandler = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('Page changed to:', location.pathname);
    checkUserStatusAndRedirect();
  }, [location]);

  

  return null; 
};

export default RouteChangeHandler;



// WEBPACK FOOTER //
// ./src/features/director/pages/LogoutFromSite.tsx